import React from "react";




export default ({ classes, slideName, header, description, imgSrc }) => {

  return (

    <div className={classes.slideContent}>

      <div className={classes.leftContainer}>

        <div className={classes.step}>{slideName}</div>

        <div className={classes.stepBar}></div>

        <div className={classes.headerSlide}>{header}</div>

        <div className={classes.headerDescription}>{description}</div>

        {/* <Button className={classes.button} variant="secondary">Learn More</Button> */}

      </div>

      <img className={classes.image} src={imgSrc} alt="slides" />

    </div>

  );

}; 